import React from 'react';
import DeviationDumbView from '../DeviationViews/Dumbo';
import DeviationLink from '../Duperbrowse/DeviationLink';
const PollOptionThumb = ({ deviation , size  })=>{
    return deviation ? /*#__PURE__*/ React.createElement(DeviationLink, {
        deviation: deviation,
        target: "_blank"
    }, /*#__PURE__*/ React.createElement(DeviationDumbView, {
        deviation: deviation,
        width: size,
        height: size
    })) : // Deviation is inactive/deleted
    // Render an Unknown thumb (a "null" deviation) instead
    /*#__PURE__*/ React.createElement(DeviationDumbView, {
        deviation: {},
        width: size,
        height: size
    });
};
PollOptionThumb.displayName = 'PollOptionThumb';
export default PollOptionThumb;
